import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
// import convertToExcel from "../../../../components/ExportToExcel";
// import convertToExcel from "./ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { toast } from "react-toastify";
import convertToExcel from "../../../../components/ExportToExcel";

const FarmerComprehensiveDataReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [seasonData, setSeasondata] = useState([]);
  const [RanchData, setRanchdata] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [seasonId, setSeasonId] = useState(0);
  const [ranchId, setRanchId] = useState(0);
  const [seasonName, setSeasonName] = useState();
  const [fieldName, setFieldName] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);
  const [RanchName, setRanchName] = useState();
  const [cropId, setCropId] = useState("");
  const [cropData, setCropData] = useState([]);
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [regionId, setRegionId] = useState();


  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getRanchWeighBridgeFarmerData } = useHttp();

  const fillRanchWeighBridgeFarmerData = (
    employeeId,
    seasonId,
    cropId,
    farmerNo,
    ranchId,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (ranchId && ranchId !== 0) {
      urlfilter += `&ranchId=${ranchId}`;
    }

    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }

    if (seasonId != 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }

    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }
    if (cropId && cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }

    var url = `/api/farmerComprehensiveDataReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getRanchWeighBridgeFarmerData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillRanchWeighBridgeFarmerData(
      employeeId,
      seasonId,
      cropId,
      farmerNumber,
      ranchId
    );
  }, [
    seasonId,
    employeeId,
    ranchId,
    fieldName,
    selectedFromDate,
    cropId,
    selectedToDate,
    showDateFilter,
    farmerNumber,
  ]);

  useEffect(() => {

    if (!ranchId) {
      setFieldOptions([]);
      return;
    }

    getRanchWeighBridgeFarmerData(
      {
        url: `/api/farmerComprehensiveDataReport/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&ranchId=${ranchId}`,
      },
      (res) => {

        console.log("FIELD API RESPONSE", res);

        const reportData = Array.isArray(res)
          ? res
          : res?.data || [];

        const uniqueFields = [
          ...new Set(
            reportData
              .map((item) => item.fieldCode?.trim())
              .filter(
                (item) =>
                  item !== null &&
                  item !== undefined &&
                  item !== ""
              )
          ),
        ];

        console.log("UNIQUE FIELDS", uniqueFields);

        const fieldList = uniqueFields.map((f) => ({
          fieldCode: f,
        }));

        setFieldOptions(fieldList);
      }
    );

  }, [ranchId]);

  const fieldsToExport = [
    "createdDate",
    "farmerName",
    "farmerNo",
    "ranchName",

    "fieldCode",
    "plotName",
    "seasonName",
    "plotArea",
    "cropName",
    "Owner",
    "numberOfBags",
    "averageWeightOfBag",
    "totalWeight",
    "fruitQuality",
  ];

  const customHeaders = [
    "Date",
    "Farmer Name",
    "Farmer No",
    "Ranch",

    "Field Name",
    "Plot No",
    "Season Name",
    "Field Size",
    "Crop",
    "Owner",
    "Number of Bags",
    "Average Weight of Bag",
    "Total Weight",
    "Fruit Quality",
  ];

  const handleExportExcel = async () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    const filename = "FarmerComprehensiveDataReport.xlsx";

    const formattedData = data.map((item) => ({
      ...item,
      invoiceStatus:
        item.invoiceStatus === 1 || item.invoiceStatus === true ? "Yes" : "No",
    }));

    convertToExcel(formattedData, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getSeasonData } = useHttp();
  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setSeasondata(data);
      }
    );
  }, [getSeasonData]);

  const { sendRequest: getCropData } = useHttp();

  useEffect(() => {
    getCropData(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setCropData(data.output || []);
      }
    );
  }, [getCropData]);

  // const { sendRequest: getprocurementData } = useHttp();
  // const fillprocurementData = (e) => {
  //   if (e) e.preventDefault();
  //   let urlfilter = "";

  //   if (employeeId > 0) urlfilter += `&fieldExecutiveId=${employeeId}`;
  //   if (seasonId > 0) urlfilter += `&seasonId=${seasonId}`;
  //   if (ranchId > 0) urlfilter += `&ranchId=${ranchId}`;
  //   if (farmerNumber) urlfilter += `&farmerNo=${farmerNumber}`;

  //   const url = `/api/farmerScoreboardReport/?orgId=${localStorage.getItem(
  //     "orgId"
  //   )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

  //   getprocurementData({ url }, (data) => {
  //     setData(data);
  //   });
  // };

  const { sendRequest: getRanchData } = useHttp();
  useEffect(() => {
    getRanchData(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setRanchdata(data);
      }
    );
  }, [getRanchData]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/compresiveFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);


  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title mx-3">
              Farmer Comprehensive Data
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Crop Name</label>

                  <select
                    className="form-control"
                    value={cropId}
                    onChange={(e) => {
                      setCropId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {cropData &&
                      cropData.map((x) => (
                        <option key={x.CropId} value={x.CropId}>
                          {x.CropName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              {/* Season Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season Name</label>
                  <select
                    id="seasonId"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonId"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      var sId = "";

                      if (e.target.value !== "Select") {
                        sId = e.target.value;
                      }

                      setSeasonId(sId);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {seasonData &&
                      seasonData.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Ranch Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch Name</label>
                  <select
                    id="ranchId"
                    className="form-control"
                    ref={(el) => (frmRef.current["ranchId"] = el)}
                    value={ranchId}
                    onChange={(e) => {
                      var rId = "";
                      if (e.target.value != "--Select--") {
                        rId = e.target.value;
                      }
                      setRanchId(rId);
                      setFieldName("");
                      // setRanchName(rId)
                      setEmployeeId(0);
                      
                    }}
                  >
                    <option value="">Select</option>
                    {RanchData &&
                      RanchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Field Name</label>
                  <select
                    className="form-control"
                    value={fieldName}
                    onChange={(e) => {
                      setFieldName(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {fieldOptions.map((x, i) => (
                      <option key={i} value={x.fieldCode}>
                        {x.fieldCode}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Procurement Officer */}
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Field Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}

              {/* Farmer Number */}
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>

              {/* Date Filter */}
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={() => {
                      fillRanchWeighBridgeFarmerData(
                        employeeId,
                        seasonId,
                        cropId,
                        farmerNumber,
                        ranchId
                      );
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        {/* Report Table */}
        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={handleExportExcel}
                disabled={loading}
              >
                {loading ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : (
                  <i className="fas fa-file-excel"></i>
                )}
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Date</th>
                          <th>Farmer No</th>
                          <th>Farmer Name</th>

                          <th>Ranch Name</th>

                          <th>Field Name</th>
                          <th>Plot No</th>
                          <th>SeasonName</th>
                          <th>Field Size</th>
                          <th>Crop</th>
                          <th>Fruit Quality</th>
                          <th>Owner</th>
                          <th>Number of Bags</th>
                          <th>Average Weight of Bag</th>
                          <th>Total Weight</th>

                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => (
                            <tr key={i} className="tablerowview">
                              <td>{itm.createdDate}</td>
                              <td>{itm.farmerNo}</td>
                              <td>{itm.farmerName}</td>

                              <td>{itm.ranchName}</td>

                              <td>{itm.fieldCode}</td>
                              <td>{itm.plotName}</td>
                              <td>{itm.seasonName}</td>
                              <td>{formatNumber(itm.plotArea)}</td>
                              <td>{itm.cropName}</td>
                              <td>{itm.fruitQuality}</td>
                              <td>{itm.Owner}</td>
                              <td>{formatNumber(itm.numberOfBags)}</td>
                              <td>{formatNumber(itm.averageWeightOfBag)}</td>
                              <td>{formatNumber(itm.totalWeight)}</td>

                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerComprehensiveDataReport;
